import { IDashboard } from '../interfaces';

export const initialDashboard: IDashboard = {
  progress: null,
};
